
import { Purchase } from "@/models/base";
import { PurchaseService } from "@/services/purchase-service";
import { v4 } from "uuid";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
export default Vue.extend({
	data(){
		return {
			input: "",
			foundPurchases: [] as Purchase[],
			count: 0,
			fetchThread: "",
			fetchedInput: ""
		};
	},
	props: {
		value: {
			type: Object as ()=>Purchase,
		},
		fancy: Boolean,
		label: [String, Object as ()=>TranslateResult],
		compactSearch: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		icon():string | undefined{
			if(this.compactSearch) {
				return "search";
			}
			return undefined;
		}
	},
	watch: {
		async input(input:string){
			if (input.match(/^\s*$/)) {
				this.foundPurchases = [];
				return;
			}
			let threadId = v4();
			this.fetchThread = threadId;
			try{
				let result = await PurchaseService.search(input);
				if (this.fetchThread != threadId) return;
				this.foundPurchases = result.data;
				this.count = result.records;
				this.fetchedInput = input;
				this.fetchThread = "";
			}catch(err){
				if (this.fetchThread == threadId){
					this.fetchThread = "";
				}
			}
		},
		value: {
			immediate: true,
			handler(purchase:Purchase){
				if (this.value) {
					this.input = purchase.ComputedFriendlyID;
				} else {
					this.input = "";
				}
			}
		}
	},
	methods: {
		trigger(){
			if(this.compactSearch){
				this.$emit("search");
				return;
			}
		},
		async selectPurchase(purchase:Purchase){
			purchase = await PurchaseService.getPurchase(purchase.ID);
			this.$emit("input", purchase);
		},
		onBlur() {
			this.foundPurchases = [];
			if (this.value){
				this.input = this.value.ComputedFriendlyID;
			}
			this.$emit("blur");
		},
		focus() {
			(this.$refs.input as any).focus();
		},
		blur() {
			(this.$refs.input as any).blur();
		},
		async fetchMore(){
			if (this.fetchedInput != this.input) return;

			if (this.foundPurchases.length >= this.count) return;
			let threadId = v4();
			this.fetchThread = threadId;
			try{
				let result = await PurchaseService.search(this.fetchedInput, this.foundPurchases.length, 20);
				if (this.fetchThread != threadId) return;
				this.foundPurchases.push(...result.data);
				this.fetchThread = "";
			}catch(err){
				if (this.fetchThread == threadId){
					this.fetchThread = "";
				}
			}
		}

	}
});
